import Config from 'config';
import { fork, call, put, select } from 'redux-saga/effects';
import request from '../../../lib/request';
import waitForSession from '../../../lib/wait-for-session';
import { getUserId } from '../../session/getters';
import {
  paymentPlanId,
  installments
} from '../getters';

import {
  ON_PAYMENT_PLAN_MOUNT_SUCCESS,
  ON_PAYMENT_PLAN_MOUNT_ERROR,
  PAY_INSTALLMENT_SUCCESS,
  PAY_INSTALLMENT_ERROR,
  PAY_INSTALLMENTS_SUCCESS,
  PAY_INSTALLMENTS_ERROR
} from '../actions';

import {
  ADD_FLASH_MESSAGE
} from '../../my-tickets/actions';

export function* requestAndPut(requestParameters, actionCreator) {
  const result = yield call(...requestParameters);
  yield put(actionCreator(result));
}

export const requestPaymentPlanActionCreator = paymentPlan => ({
  type: ON_PAYMENT_PLAN_MOUNT_SUCCESS,
  payload: paymentPlan ? paymentPlan : false
});

export function requestTicket(paymentPlanId) {
  const options = {
    credentials: 'include'
  };

  return request(`${Config.api.base}/tickets/${paymentPlanId}`, options)
    .then(resp => resp.json());
}

export function* fetchPaymentPlanData() {
  yield call(waitForSession);
  const userId = yield select(getUserId);

  try {
    if (!userId) {
      throw new Error('No user - aborting');
    }

    const id = yield select(paymentPlanId);

    yield fork(requestAndPut, [requestTicket, id], requestPaymentPlanActionCreator);
  }
  catch (e) {
    yield put({ type: ON_PAYMENT_PLAN_MOUNT_ERROR, payload: e });
  }
}

export function* payInstallment({ payload }) {
  function pay(installments, number) {
    const installment = installments
      .map(installment => {
        installment.token = null;
        return installment;
      })
      .find(installment => installment.number === number);

    const options = {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ installment })
    };

    return request(`${Config.api.base}/installments/${installment.id}`, options)
      .then(res => res.json());
  }

  try {
    const installmentData = yield select(installments);
    const res = yield pay(installmentData, payload.number);

    if (res && res.errors) {
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'payInstallmentError' }});
      yield put({ type: PAY_INSTALLMENT_ERROR, payload: res.errors });
    }
    else {
      yield put({ type: PAY_INSTALLMENT_SUCCESS, payload: res });
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'success', message: 'payInstallmentSuccess' }});
    }
  }
  catch (e) {
    yield put({ type: PAY_INSTALLMENT_ERROR, payload: e });
    yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'payInstallmentError' }});
  }
}

export function* payAllInstallments() {
  function pay(installmentId) {
    const options = {
      method: 'PUT',
      credentials: 'include'
    };

    return request(`${Config.api.base}/tickets/${installmentId}/pay_installments`, options)
      .then(res => res.json());
  }

  try {
    const installmentId = yield select(paymentPlanId);
    const res = yield pay(installmentId);

    if (res && res.errors) {
      yield put({ type: PAY_INSTALLMENTS_ERROR, payload: e });
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'payInstallmentError' }});
    }
    else {
      yield put({ type: PAY_INSTALLMENTS_SUCCESS, payload: res });
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'success', message: 'payInstallmentSuccess' }});
    }
  }
  catch (e) {
    yield put({ type: PAY_INSTALLMENTS_ERROR, payload: e });
    yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'payInstallmentError' }});
  }
}



// WEBPACK FOOTER //
// ./src/modules/payment-plans/actions/sagas.js